module.exports = __webpack_public_path__ + "b4db94261b43500e2153b22743095aa9.png";